import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { Subscriber } from 'types/electionService';
import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { updateEmail } from 'api/operations/electionService';
import { inviteSubscriber } from 'api/operations/userService';
import { action, makeObservable, observable, runInAction } from 'mobx';
import ModalDelegate from 'store/general/modalDelegate';

export interface SendInvitationContext {
  employee: Subscriber;
  groupId: string;
  refreshData: () => Promise<void> | void;
}

interface Fields extends DefaultFormFields {
  email: FormControl<string>;
}

export class SendInvitationModalStore extends ModalDelegate {
  private readonly _contextualData: SendInvitationContext;

  public readonly form = new FormController<Fields>(
    {
      email: new FormControl('', { validations: ['isEmailValid'], optional: false }),
    },
    {
      onSubmit: this._sendInvitation.bind(this),
    },
  );

  private async _sendInvitation(): Promise<void> {
    await runInAction(async () => {
      const subscriberData = {
        firstName: this._contextualData.employee.common.firstName,
        lastName: this._contextualData.employee.common.lastName,
        email: this.form.fields.email.value,
        userType: this._contextualData.employee.subSERole,
        groupId: this._contextualData.groupId,
        subscriberId: this._contextualData.employee.id,
      };

      try {
        await inviteSubscriber(subscriberData);
      } catch (error) {
        throw new Error('There is a user with this email already!');
      }
      await runInAction(async () => {
        await updateEmail(this._contextualData.employee.id, this.form.fields.email.value);
        runInAction(() => {
          toastManager.addToast('Invitation sent successfully', ToastColorTypes.SUCCESS);
          void this._contextualData.refreshData();
        });
      });
    });
  }

  constructor(props: SendInvitationContext) {
    super();
    this._contextualData = props;

    if (props.employee.email) {
      this.form.fields.email.value = props.employee.email;
    }

    makeObservable<SendInvitationModalStore, '_sendInvitation'>(this, {
      _sendInvitation: action.bound,
      form: observable,
    });
  }
}
